var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-exam-layout", {
    attrs: { "exam-loading": _vm.examLoading },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "space-around" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _vm.examInfoData.manageName
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content: _vm.examInfoData.manageName,
                              placement: "right",
                            },
                          },
                          [
                            _c("h3", { staticClass: "name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.examInfoData.manageName ||
                                    _vm.examInfoData.name
                                )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.examInfoData.name
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content: _vm.examInfoData.name,
                              placement: "right",
                            },
                          },
                          [
                            _c("h3", { staticClass: "name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.examInfoData.manageName ||
                                    _vm.examInfoData.name
                                )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("h3", { staticClass: "time" }),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "user" }, [
                    _vm._v(_vm._s(_vm.examInfoData.examUserName)),
                  ]),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "left",
        fn: function () {
          return [
            _c("p", { staticClass: "sub-title list bg pd-10" }, [
              _vm._v("答题卡"),
            ]),
            _c(
              "div",
              { staticClass: "card-list" },
              [
                !_vm.previewStatus
                  ? _c(
                      "el-row",
                      { staticClass: "card-tips pd-10" },
                      [
                        _c(
                          "el-col",
                          { staticClass: "a1", attrs: { span: 8 } },
                          [_vm._v("已答：" + _vm._s(_vm.answeredCount))]
                        ),
                        _c(
                          "el-col",
                          { staticClass: "a2", attrs: { span: 8 } },
                          [
                            _vm._v(
                              "未答：" +
                                _vm._s(_vm.speedLength - _vm.answeredCount)
                            ),
                          ]
                        ),
                        _c(
                          "el-col",
                          { staticClass: "a3", attrs: { span: 8 } },
                          [_vm._v("标记：" + _vm._s(_vm.markedCount))]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "el-row",
                      { staticClass: "card-tips pd-10" },
                      [
                        _c(
                          "el-col",
                          { staticClass: "a1", attrs: { span: 8 } },
                          [
                            _vm._v(
                              "正确：" + _vm._s(_vm.examInfoData.corretNum)
                            ),
                          ]
                        ),
                        _c(
                          "el-col",
                          { staticClass: "error", attrs: { span: 8 } },
                          [
                            _vm._v(
                              "错误：" +
                                _vm._s(
                                  _vm.speedLength - _vm.examInfoData.corretNum
                                )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                _vm._l(_vm.examInfoData.items, function (data) {
                  return [
                    _c(
                      "p",
                      {
                        key: data.examPaperItemsId,
                        staticClass: "sub-title list pd-10",
                      },
                      [
                        _vm._v(" " + _vm._s(data.name)),
                        _c("span", { staticClass: "sub" }, [
                          _vm._v(
                            "（共" +
                              _vm._s(data.totalNum) +
                              "题，合计" +
                              _vm._s(data.totalScore) +
                              "分）"
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        key: data.examPaperId + data.examPaperItemsId,
                        staticClass: "question-list",
                      },
                      [
                        _vm._l(data.questions, function (q, i) {
                          return [
                            data.questionsItems.value != "group"
                              ? _c(
                                  "div",
                                  {
                                    key: q.examPaperId,
                                    class: [
                                      "item",
                                      q.handleResults,
                                      q.answered ? "answered" : "",
                                      q.marked ? "marked" : "",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toScroll(q.examQuestionsId)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(++i) + " ")]
                                )
                              : _vm._l(q.children, function (childValue) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: childValue.examPaperId,
                                        class: [
                                          "item",
                                          childValue.handleResults,
                                          childValue.answered ? "answered" : "",
                                          childValue.marked ? "marked" : "",
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.toScroll(
                                              childValue.examQuestionsId,
                                              childValue.groupIndex - 1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(childValue.groupIndex) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "main",
        fn: function () {
          return [
            _vm._l(_vm.examInfoData.items, function (data, index) {
              return [
                _c(
                  "p",
                  {
                    key: data.examPaperItemsId,
                    staticClass: "sub-title list bg pd-20",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dsf.math.toChinesNum(++index) + "、" + data.name
                        ) +
                        " "
                    ),
                    data.score && data.totalScore
                      ? _c("span", { staticClass: "sub" }, [
                          _vm._v(
                            " （共" +
                              _vm._s(data.questions.length) +
                              "题，合计" +
                              _vm._s(data.totalScore) +
                              "分） "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    key: data.examPaperItemsId + index,
                    staticClass: "exam-content",
                  },
                  _vm._l(data.questions, function (subjects, examIndex) {
                    return _c(
                      "div",
                      {
                        key: subjects.examQuestionsId,
                        ref: "question" + subjects.examQuestionsId,
                        refInFor: true,
                      },
                      [
                        _c("dsf-exam-item-box", {
                          attrs: {
                            "hide-mark": true,
                            "show-score": _vm.showScore,
                            previewStatus: _vm.previewStatus,
                            readOnly: _vm.isReadOnly,
                            subjects: subjects,
                            "exam-index": examIndex,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "right",
        fn: function () {
          return [
            _c("div", { staticClass: "timer" }, [
              _c("p", { staticClass: "txt" }, [_vm._v("作答时间")]),
              _c("p", { staticClass: "result-time" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getTime.hours +
                        ":" +
                        _vm.getTime.minutes +
                        ":" +
                        _vm.getTime.seconds
                    ) +
                    " "
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "current-progress" },
              [
                _c("p", { staticClass: "txt" }, [_vm._v("作答进度")]),
                _c("el-progress", {
                  attrs: {
                    percentage: _vm.percentageNumber,
                    format: _vm.format,
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "timer" }, [
              _c("p", { staticClass: "txt" }, [_vm._v("考试成绩")]),
              _c("p", { staticClass: "result-time" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$route.query.type == "preview"
                        ? "- -"
                        : _vm.examInfoData.showText
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "current-progress" }, [
              _c("p", { staticClass: "txt" }, [_vm._v("考试总分")]),
              _c("p", { staticClass: "aside-text" }, [
                _vm._v(_vm._s(_vm.examInfoData.totalScore) + " 分"),
              ]),
            ]),
            _c("dsf-setting-font-size"),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }